export const Endpoints = Object.freeze({
    LatestRovers: Symbol.for("/latest-rovers"),
    RoverDataStats: Symbol.for("/rover-data-stats"),
    RoversByName: Symbol.for("/rovers-by-name"),
    RoversByYear: Symbol.for("/rovers-by-year"),
    RoverAssets: Symbol.for("/asset"),
    RoverLogs: Symbol.for('/logs')
})